
      export const versions = {
        commit: '5b6f8ee620e71e2127ee5af6eead035e970d72e1',
        branch: 'HEAD'
      };
